// Points service (Phase 1.8)
// Single entry point for awarding contribution points.
// Points amounts are decided server-side by the award_points() SECURITY DEFINER function;
// duplicate awards are silently ignored (UNIQUE constraint on user/action/ref).

import { supabase } from './supabaseClient';

// actionType: 'create_event' | 'join_event' | 'new_friend' | 'create_travel_post' | 'comment'
// refId: related entity UUID (event id, friendship id, travel post id...)
export async function awardPoints(actionType, refId) {
  try {
    const { error } = await supabase.rpc('award_points', {
      p_action_type: actionType,
      p_ref_id: refId,
    });
    if (error) throw error;
  } catch (err) {
    // Points are a non-critical enhancement — log but never block the main flow.
    console.error(`awardPoints failed (${actionType}):`, err);
  }
}
